import React from 'react';

import styles from './AiChatbot.module.scss';

export function IncomingMessage({ text }) {
  return (
    <div className={styles.incomingMessage}>
      {text}
      <div onClick={() => navigator.clipboard.writeText(text)}>
        <span className={'ic-copy'}> </span> Copy
      </div>
    </div>
  );
}
